import React, { useState } from 'react'
// import { sendFaqEmail } from '../../utils/emailService' // Disabled - using only contact form

function FaqContact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage({ type: '', text: '' });

        // Email functionality disabled - using only contact form
        setSubmitMessage({ type: 'error', text: 'Bu form şu anda devre dışı. Lütfen iletişim sayfasındaki formu kullanın.' });
        setIsSubmitting(false);
        
        // Disabled code:
        // try {
        //     const result = await sendFaqEmail(formData);
        //     if (result.success) {
        //         setSubmitMessage({ type: 'success', text: 'Sorunuz başarıyla gönderildi!' });
        //         setFormData({ name: '', email: '', subject: '', message: '' });
        //     } else {
        //         setSubmitMessage({ type: 'error', text: result.message });
        //     }
        // } catch (error) {
        //     setSubmitMessage({ type: 'error', text: 'Bir hata oluştu. Lütfen tekrar deneyin.' });
        // } finally {
        //     setIsSubmitting(false);
        // }
    };

    return (
        <div
            className="bg-top-center space overflow-hidden"
            style={{background: "url(/assets/img/bg/tour_bg_3.jpg)", backgroundRepeat: "no-repeat", position: "relative", zIndex: "1"}}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-11">
                        <div className="">
                            <div className="title-area text-center mb-30">
                                <span className="sub-title style1">Meet with Our Guide</span>
                                <h2 className="sec-title">Do You Have Any&nbsp;More Questions?</h2>
                            </div>
                            <form
                                onSubmit={handleSubmit}
                                className="contact-form ajax-contact"
                            >
                                <h3 className="sec-title mb-30">Book a tour</h3>
                                <div className="row">
                                    <div className="col-md-6 form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            id="name3"
                                            placeholder="First Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <img src="assets/img/icon/user.svg" alt="" />
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            id="email3"
                                            placeholder="Your Mail"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        <img src="assets/img/icon/mail.svg" alt="" />
                                    </div>
                                    <div className="form-group col-12">
                                        <select
                                            name="subject"
                                            id="subject"
                                            className="form-select nice-select"
                                            value={formData.subject}
                                            onChange={handleChange}
                                        >
                                            <option value="" disabled>
                                                Select Tour Destination
                                            </option>
                                            <option value="Africa Adventure">Africa Adventure</option>
                                            <option value="Africa Wild">Africa Wild</option>
                                            <option value="Asia">Asia</option>
                                            <option value="Scandinavia">Scandinavia</option>
                                            <option value="Western Europe">Western Europe</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-12">
                                        <textarea
                                            name="message"
                                            id="message"
                                            cols={30}
                                            rows={3}
                                            className="form-control"
                                            placeholder="Your Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        <img src="assets/img/icon/chat.svg" alt="" />
                                    </div>
                                    <div className="form-btn col-12 mt-24">
                                        <button 
                                            type="submit" 
                                            className="th-btn style3"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Gönderiliyor...' : 'Send message'}
                                            <img src="assets/img/icon/plane.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                                {submitMessage.text && (
                                    <p className={`form-messages mb-0 mt-3 ${submitMessage.type === 'success' ? 'text-success' : 'text-danger'}`}>
                                        {submitMessage.text}
                                    </p>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FaqContact
